import React from 'react'
import HomePage from './pages/HomePage'
import MembershipPage from './pages/MembershipPage'
import SignInPage from './pages/SignInPage'
import SignInLinkPage from './pages/SignInLinkPage'
import SignUpPage from './pages/SignUpPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import ConfirmEmailGatePage from './pages/ConfirmEmailGatePage'
import EmailConfirmedPage from './pages/EmailConfirmedPage'
import PaymentDetailsPage from './pages/PaymentDetailsPage'
import UpdatePaymentMethodPage from './pages/UpdatePaymentMethodPage'
import PaymentMethodUpdatedPage from './pages/PaymentMethodUpdatedPage'
import ApplyForAccessPage from './pages/ApplyForAccessPage'
import AlreadyRequestedScreen from './pages/AlreadyRequestedScreen'
import RejectedScreen from './pages/RejectedScreen'
import LegalPage from './pages/LegalPage'

const CivicLensApp = ({ page, ...props }) => {
  const renderPage = () => {
    switch (page) {
      case 'home':
        return <HomePage {...props} />
      case 'membership':
        return <MembershipPage {...props} />
      case 'sign_in':
        return <SignInPage {...props} />
      case 'sign_in_link':
        return <SignInLinkPage {...props} />
      case 'sign_up':
        return <SignUpPage {...props} />
      case 'forgot_password':
        return <ForgotPasswordPage {...props} />
      case 'reset_password':
        return <ResetPasswordPage {...props} />
      case 'confirm_email':
        return <ConfirmEmailGatePage {...props} />
      case 'email_confirmed':
        return <EmailConfirmedPage {...props} />
      case 'subscribe_payment':
        return <PaymentDetailsPage {...props} />
      case 'update_payment_method':
        return <UpdatePaymentMethodPage {...props} />
      case 'payment_method_updated':
        return <PaymentMethodUpdatedPage {...props} />
      case 'subscribe_apply':
        return <ApplyForAccessPage {...props} />
      case 'subscribe_requested':
        return <AlreadyRequestedScreen {...props} />
      case 'application_rejected':
        return <RejectedScreen {...props} />
      case 'terms':
        return <LegalPage doc="terms" {...props} />
      case 'privacy':
        return <LegalPage doc="privacy" {...props} />
      default:
        return <HomePage {...props} />
    }
  }

  return renderPage()
}

export default CivicLensApp
